/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { CashReceiptNonMatTableHead, CashReceiptTableHead } from './TableHead';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
import { quarterToDate } from '../../../../SharedModules/utilities/dateUtilities';
import {
  autoFormateDate,
  fromQtrToDT,
  toQtrToDT,
  tabHighLigther,
  validateDateQuarter,
} from '../../../../SharedModules/utilities/utilities';
export default function DispCashReceiptSummary() {
  const dispatch = useDispatch();
  const [resultList, setResultList] = React.useState([]);
  const {
    isLoading,
    fromDateValue,
    toDateValue,
    searchResult,
    manufacturerSelectedID,
    manufacturerSelectedName,
    allRebateProgram,
    selectedReport,
    rebateProgrameName: rebateProgramName,
  } = useSelector((state) => state?.sharedState?.CashReceiptSummaryReducer);
  const [filteredRows, setFilteredRow] = useState([]);
  const [fullScreenView, setfullScreenView] = useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const normalizeQuarterPattern = (val = '') => {
    let v = (val || '').trim().toUpperCase().replace(/\s+/g, '');

    let m = v.match(/^(20\d{2})Q([1-4])$/);
    if (m) return `${m[2]}Q${m[1]}`;

    m = v.match(/^Q([1-4])(20\d{2})$/);
    if (m) return `${m[1]}Q${m[2]}`;

    return v;
  };

  const isQuarterToken = (v) => /^[1-4]Q20\d{2}$/.test(v);
  const rawBegin = fromDateValue;
  const rawEnd = toDateValue || fromDateValue;
  const bNorm = normalizeQuarterPattern(rawBegin);
  const eNorm = normalizeQuarterPattern(rawEnd);

  const effectiveBegin = isQuarterToken(
    /^[1-4]Q\d{2}$/.test(bNorm) ? autoFormateDate(bNorm) : bNorm
  )
    ? fromQtrToDT(/^[1-4]Q\d{2}$/.test(bNorm) ? autoFormateDate(bNorm) : bNorm)
    : rawBegin;
  const effectiveEnd = isQuarterToken(
    /^[1-4]Q\d{2}$/.test(eNorm) ? autoFormateDate(eNorm) : eNorm
  )
    ? toQtrToDT(/^[1-4]Q\d{2}$/.test(eNorm) ? autoFormateDate(eNorm) : eNorm)
    : rawEnd;
  console.log('effectiveEnd', effectiveEnd);

  const dateRange = {
    fromDate: effectiveBegin,
    toDate: toDateValue === '' ? effectiveBegin : effectiveEnd,
  };
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  // React.useEffect(() => {
  //   setResultList(searchResult);
  // }, [searchResult]);

  React.useEffect(() => {
    if (searchResult && searchResult.length > 0) {
      const updatedResultList = searchResult.map((item) => {
        return {
          ...item,
          totalPrincipalAmt: item.principalAmtMat + item.principalAmtNonMat,
          totalQroaAmtCal: item.qroaMatAmt + item.qroaNonMatAmt,
        };
      });

      setResultList(updatedResultList);
    }
  }, [searchResult]);

  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum = (property) => {
    // const displayedRows = resultList;
    const displayedRows = filterApply ? filteredRows : resultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : '0.00';
  };

  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        qtr: 'Total',
        principalPaidAmt: sum('principalPaidAmt'),
        interestPaidAmt: sum('interestPaidAmt'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [resultList, filteredRows, filterApply]);

  const onFilterChanged = (rowData) => {
    setFilteredRow(rowData);
  };

  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum1 = (property) => {
    // const displayedRows = resultList;
    const displayedRows = filterApply ? filteredRows : resultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : '0.00';
  };

  const createData1 = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        qtr: 'Total',
        totalPrincipalAmt: sum1('totalPrincipalAmt'),
        principalAmtMat: sum1('principalAmtMat'),
        principalAmtNonMat: sum1('principalAmtNonMat'),
        interestAmtNonMat: sum1('interestAmtNonMat'),
        totalQroaAmtCal: sum1('totalQroaAmtCal'),
        qroaMatAmt: sum1('qroaMatAmt'),
        qroaNonMatAmt: sum1('qroaNonMatAmt'),
      });
    }
    return result;
  };
  const pinnedBottomRowData1 = useMemo(() => {
    return createData1(1, 'Bottom');
  }, [resultList, filteredRows, filterApply]);

  const firstInfo = `Manufacturer: ${
    manufacturerSelectedID === 'ALL' ? 'ALL' : manufacturerSelectedName
  }`;
  const secondInfo = `Deposit from ${`${dateRange.fromDate} to ${dateRange.toDate}`}`;
  const thirdInfo = `${
    allRebateProgram ? 'ALL' : rebateProgramName?.replace('|', '-')
  }`;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={isLoading} />

      {!fullScreenView && (
        <>
          <CustomSeparator
            parent1="State Reports"
            parent2="Display Cash Receipt Summary"
          />
          <div className="tab-body custom-search-dates">
            <div className="mui-custom-form input-md field-xl">
              <div className="row mb-2">
                <div className="col-6">
                  <TextField
                    label="Rebate Program :"
                    id="RebateProgramdisp"
                    fullWidth
                    placeholder=""
                    inputProps={{ id: 'RebateProgramdisp' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      allRebateProgram
                        ? 'ALL'
                        : rebateProgramName?.replace('|', '-')
                    }
                    name="RebateProgram"
                    disabled
                  />
                </div>
                <div className="col-6">
                  <TextField
                    label="Manufacturer :"
                    id="manufacturer"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      manufacturerSelectedID === 'ALL'
                        ? 'ALL'
                        : `${manufacturerSelectedID} - ${manufacturerSelectedName}`
                    }
                    name="dateRange"
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <TextField
                    label="Begin Date: "
                    id="beginDate"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={dateRange.fromDate}
                    name="fromDate"
                    disabled
                  />
                </div>
                <div className="col-6">
                  <TextField
                    label="End Date: "
                    id="endDate"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={dateRange.toDate}
                    name="toDate"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {selectedReport == 'Detail' && (
        <TableGridWithFeatures
          rowData={
            resultList?.map((item) => {
              return {
                ...item,
                principalPaidAmt: item.principalPaidAmt
                  ? item.principalPaidAmt
                  : '0.00',
                interestPaidAmt: item.interestPaidAmt
                  ? item.interestPaidAmt
                  : '0.00',
              };
            }) || []
          }
          columnDefs={CashReceiptTableHead}
          rowMultiSelectWithClick
          data-testid="onEditingStopped"
          enterMovesDown
          showResetFilter={false}
          hideTotalCount={false}
          exportFile
          fileName="CashReceiptSummary"
          reportName="Cash Receipt Summary"
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
          info={{ firstInfo, secondInfo, thirdInfo }}
          pinnedBottomRowData={pinnedBottomRowData}
          onFilterData={onFilterChanged}
          getFilterApply={getFilterApply}
          frameworkComponents={{
            AmountComponent: CustomGridCellRendererComponent,
            TotalText: (cellInfo) => {
              if (cellInfo?.data?.isBottomRow) {
                return <span className="semiBoldText">Total</span>;
              }
              return cellInfo?.value;
            },
          }}
        />
      )}
      {selectedReport == 'Summary' && (
        <TableGridWithFeatures
          rowData={
            resultList?.map((item) => {
              return {
                ...item,
                interestAmtMat: item.interestAmtMat
                  ? item.interestAmtMat
                  : '0.00',
                interestAmtNonMat: item.interestAmtNonMat
                  ? item.interestAmtNonMat
                  : '0.00',
                principalAmtMat: item.principalAmtMat
                  ? item.principalAmtMat
                  : '0.00',
                principalAmtNonMat: item.principalAmtNonMat
                  ? item.principalAmtNonMat
                  : '0.00',
                qroaMatAmt: item.qroaMatAmt ? item.qroaMatAmt : '0.00',
                qroaNonMatAmt: item.qroaNonMatAmt ? item.qroaNonMatAmt : '0.00',
                totalQroaAmt: item.totalQroaAmt ? item.totalQroaAmt : '0.00',
              };
            }) || []
          }
          columnDefs={CashReceiptNonMatTableHead}
          rowMultiSelectWithClick
          data-testid="onEditingStopped"
          enterMovesDown
          showResetFilter={false}
          hideTotalCount={false}
          exportFile
          fileName="CashReceiptSummary"
          reportName="Cash Receipt Summary"
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
          info={{ firstInfo, secondInfo, thirdInfo }}
          pinnedBottomRowData={pinnedBottomRowData1}
          onFilterData={onFilterChanged}
          getFilterApply={getFilterApply}
          frameworkComponents={{
            AmountComponent: CustomGridCellRendererComponent,
            TotalText: (cellInfo) => {
              if (cellInfo?.data?.isBottomRow) {
                return <span className="semiBoldText">Total</span>;
              }
              return cellInfo?.value;
            },
          }}
        />
      )}
    </div>
  );
}
